import { useCallback, useEffect } from "react";
import {
  sendAgentCommand,
  startConnectionMonitor,
  stopConnectionMonitor,
  useAgentConnection,
} from "./agentConnection";

/**
 * Shared companion connection state for settings UI and commands.
 * @param {{ enabled?: boolean }} options
 */
export function useDesktopAgent({ enabled = true } = {}) {
  const { connected } = useAgentConnection();

  useEffect(() => {
    if (!enabled) {
      stopConnectionMonitor();
      return undefined;
    }

    startConnectionMonitor();
    return undefined;
  }, [enabled]);

  const sendCommand = useCallback(
    (command, bearerToken) => {
      if (!enabled) return Promise.resolve(null);
      return sendAgentCommand(command, bearerToken);
    },
    [enabled],
  );

  return { connected: enabled && connected, sendCommand };
}
